// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AllocationKeyFromJSON, AllocationKeyToJSON, CommitmentCalculationFromJSON, CommitmentCalculationToJSON, EsgSustainabilityFromJSON, EsgSustainabilityToJSON, UnitOfAreaFromJSON, UnitOfAreaToJSON, } from './';
export function DatapointsRequestOptionsFromJSON(json) {
    return {
        'selectedCurrency': json['selectedCurrency'],
        'allocationKey': AllocationKeyFromJSON(json['allocationKey']),
        'commitmentCalculation': !exists(json, 'commitmentCalculation') ? undefined : CommitmentCalculationFromJSON(json['commitmentCalculation']),
        'excludeSoldAssets': !exists(json, 'excludeSoldAssets') ? undefined : json['excludeSoldAssets'],
        'unitOfArea': UnitOfAreaFromJSON(json['unitOfArea']),
        'esgSustainability': !exists(json, 'esgSustainability') ? undefined : EsgSustainabilityFromJSON(json['esgSustainability']),
    };
}
export function DatapointsRequestOptionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'selectedCurrency': value.selectedCurrency,
        'allocationKey': AllocationKeyToJSON(value.allocationKey),
        'commitmentCalculation': CommitmentCalculationToJSON(value.commitmentCalculation),
        'excludeSoldAssets': value.excludeSoldAssets,
        'unitOfArea': UnitOfAreaToJSON(value.unitOfArea),
        'esgSustainability': EsgSustainabilityToJSON(value.esgSustainability),
    };
}
